import React from "react"
import {
  BorderLineStyle,
  QuickStartBreathingEmbedContainer,
  QuickStartTextContainer,
  QuickStartTextWithPhoto,
  TextFlexTitle,
} from "./quick-start.styled"
import TextWithEmbedResolver from "../../../../../resolvers/text-with-embed/text-with-embed.resolver"
import RichText from "../../../../../resolvers/rich-text/rich-text.resolver"
import {
  AppFunctionComponent,
  TextBuilder,
  TextWithEmbedBuilder,
} from "../../../../../types"

const MuditaSVGSmallIcon: AppFunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
  >
    <path
      d="M23.8421 14.7727C23.7928 14.6745 23.7246 14.5878 23.6424 14.5177C21.588 12.8081 18.7894 12.3224 16.2877 13.2429C16.2902 10.1297 14.8839 7.18475 12.4681 5.24824C12.1813 5.01621 11.7719 5.01621 11.4851 5.24824C9.07439 7.1822 7.66812 10.1182 7.6656 13.2263C5.17273 12.3301 2.39684 12.8247 0.358831 14.5267C0.1592 14.7179 0.0315873 14.9741 0 15.2508C0.00758094 19.4961 3.41901 22.9356 7.62643 22.9407C9.19316 22.9445 10.722 22.4537 11.9994 21.5384C13.2768 22.4537 14.8068 22.9433 16.3736 22.9407C20.5835 22.9356 23.9949 19.4935 24 15.2457C24 15.0748 23.9431 14.9091 23.8421 14.7727ZM11.9766 6.91575C15.4462 10.1679 15.6458 15.6422 12.4226 19.1416C12.2799 19.2972 12.1308 19.4463 11.9766 19.5917C8.50708 16.3395 8.30745 10.8653 11.5306 7.36578C11.6734 7.21024 11.8225 7.06109 11.9766 6.91575ZM1.58947 15.5708C3.39121 14.2079 5.80195 13.9912 7.81469 15.0111C8.17226 17.1019 9.17041 19.0282 10.6664 20.5185C9.7453 21.0654 8.69534 21.3522 7.62643 21.351C4.41337 21.3459 1.76257 18.8089 1.58947 15.5708ZM16.3723 21.3535C15.292 21.3561 14.232 21.0629 13.3033 20.5045C14.7841 19.0205 15.7734 17.1108 16.1335 15.0366C18.1564 13.9823 20.5974 14.1901 22.4168 15.5708C22.2437 18.8115 19.5904 21.351 16.3736 21.3535H16.3723Z"
      fill="#C4C4C4"
    />
    <path
      d="M23.7111 9.86396C23.8033 9.86396 23.8778 9.78747 23.8766 9.6944C23.8766 9.68038 23.874 9.66508 23.8715 9.65233C22.066 3.02434 15.2773 -0.872898 8.7071 0.9476C4.51105 2.11155 1.23356 5.41853 0.0799897 9.65233C0.0559834 9.74157 0.10905 9.83464 0.198758 9.85886C0.212656 9.86268 0.226555 9.86396 0.240453 9.86396H1.53427C1.60755 9.86523 1.67325 9.81806 1.69473 9.74667C3.45098 4.01491 9.4791 0.804816 15.1597 2.57687C18.5573 3.63628 21.2169 6.31985 22.2669 9.74795C22.2884 9.81806 22.3515 9.86523 22.4236 9.86523H23.7111V9.86396Z"
      fill="#C4C4C4"
    />
  </svg>
)

interface QuickStartBreathingEmbedProps {
  sectionOne: TextWithEmbedBuilder
  sectionTwo: TextBuilder
  sectionThree: TextBuilder
  sectionFour: TextBuilder
}

const QuickStartBreathingEmbed: AppFunctionComponent<
  QuickStartBreathingEmbedProps
> = ({ sectionOne, sectionTwo, sectionThree, sectionFour }) => {
  return (
    <QuickStartBreathingEmbedContainer>
      <QuickStartTextWithPhoto>
        <TextWithEmbedResolver {...sectionOne} />
      </QuickStartTextWithPhoto>
      <div>
        <QuickStartTextContainer>
          {sectionTwo.title && (
            <TextFlexTitle>
              <MuditaSVGSmallIcon /> <h3>{sectionTwo.title}</h3>
            </TextFlexTitle>
          )}
          {sectionTwo.text && <RichText content={sectionTwo.text} />}
        </QuickStartTextContainer>
        <BorderLineStyle></BorderLineStyle>
        <QuickStartTextContainer>
          {sectionThree.title && (
            <TextFlexTitle>
              <MuditaSVGSmallIcon /> <h3>{sectionThree.title}</h3>
            </TextFlexTitle>
          )}
          {sectionThree.text && <RichText content={sectionThree.text} />}
        </QuickStartTextContainer>
        <BorderLineStyle></BorderLineStyle>
        <QuickStartTextContainer>
          {sectionFour.title && (
            <TextFlexTitle>
              <MuditaSVGSmallIcon />
              <h3>{sectionFour.title}</h3>
            </TextFlexTitle>
          )}
          {sectionFour.text && <RichText content={sectionFour.text} />}
        </QuickStartTextContainer>
      </div>
    </QuickStartBreathingEmbedContainer>
  )
}

export default QuickStartBreathingEmbed
